import gql from "graphql-tag";

export const quoteFragment = gql`
	fragment quoteFragment on Quote {
		_id
		accepted
		key
		final_price {
			total
			unit
			description
		}
		type
		declined
		last_message {
			_id
			message
		}
		first_provider_message {
			_id
			message
		}
		last_client_message {
			_id
		}
		providerMongoID
		created_at
	}
`;

export const serviceFragment = gql`
	fragment serviceFragment on Service {
		_id
		hide
		name
		active
		credits
		key
		phrase
		url
		slug
		singular
		midtail
		name_proper
	}
`;
